import { Grid, Typography, Divider } from "@mui/material";
import TabPanel from "../../Atoms/Tabs/TabPanel.js";
import ListActivities from "../Activities/Lists/ListActivities.jsx";

const ActivityPanal = (props) => {
  const {
    options,
    ActivityValue,
    activitesList,
    setActivitiesList,
    count,
    page,
    updatePagination,
    activitiesPrivilages,
    getActivities,
    filterObj,
    setOpenLoader,
    isInHouseActivity,
    setPage,
  } = props;

  return (
    <Grid container>
      {options &&
        options.map((option, index) => (
          <Grid container key={index}>
            <TabPanel value={ActivityValue} index={index} className="tab-panel">
              {index === 0 && (
                <Grid container>
                  <ListActivities
                    activitesList={activitesList}
                    setActivitiesList={setActivitiesList}
                    count={count}
                    page={page}
                    setPage={setPage}
                    updatePagination={updatePagination}
                    activitiesPrivilages={activitiesPrivilages}
                    getActivities={getActivities}
                    filterObj={filterObj}
                    setOpenLoader={setOpenLoader}
                  />
                </Grid>
              )}
              {index === 1 && (
                <Grid container>
                  <ListActivities
                    activitesList={activitesList}
                    setActivitiesList={setActivitiesList}
                    count={count}
                    page={page}
                    setPage={setPage}
                    updatePagination={updatePagination}
                    activitiesPrivilages={activitiesPrivilages}
                    getActivities={getActivities}
                    filterObj={filterObj}
                    setOpenLoader={setOpenLoader}
                  />
                </Grid>
              )}
              {index === 2 && (
                <Grid container>
                  <ListActivities
                    activitesList={activitesList}
                    setActivitiesList={setActivitiesList}
                    count={count}
                    page={page}
                    setPage={setPage}
                    updatePagination={updatePagination}
                    activitiesPrivilages={activitiesPrivilages}
                    getActivities={getActivities}
                    filterObj={filterObj}
                    setOpenLoader={setOpenLoader}
                  />
                </Grid>
              )}
              {index === 3 && (
                <Grid container>
                  <ListActivities
                    activitesList={activitesList}
                    setActivitiesList={setActivitiesList}
                    count={count}
                    page={page}
                    setPage={setPage}
                    updatePagination={updatePagination}
                    activitiesPrivilages={activitiesPrivilages}
                    getActivities={getActivities}
                    filterObj={filterObj}
                    setOpenLoader={setOpenLoader}
                  />
                </Grid>
              )}
            </TabPanel>
          </Grid>
        ))}
      {!options && (
        <Grid container>
          <ListActivities
            activitesList={activitesList}
            setActivitiesList={setActivitiesList}
            count={count}
            page={page}
            setPage={setPage}
            updatePagination={updatePagination}
            activitiesPrivilages={activitiesPrivilages}
            getActivities={getActivities}
            filterObj={filterObj}
            setOpenLoader={setOpenLoader}
            isInHouseActivity={isInHouseActivity}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ActivityPanal;
